import { ChangeEvent, useState } from 'react';

import { Button, TextField, Typography } from '@mui/material';

import { useEditableClockInputStyles } from './EditableClockInput.styles';

type EditableClockInputProps = {
  value: string;
  onChange: (value: number) => void;
  maxValue: number;
};

export const EditableClockInput = ({ value, onChange, maxValue }: EditableClockInputProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(Number(value));

  const classes = useEditableClockInputStyles();

  const handleOnChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const value = Number(evt.target.value);
    if (value > maxValue) {
      setCurrentValue(maxValue);
    } else {
      setCurrentValue(value);
    }
  };

  const handleFinishEdit = () => {
    setIsEditing(false);
    onChange(currentValue);
  };

  return isEditing ? (
    <TextField
      className={classes.root}
      color="primary"
      type="number"
      value={currentValue}
      fullWidth={false}
      autoFocus
      onBlur={handleFinishEdit}
      onChange={handleOnChange}
      onKeyPress={event => {
        if (event.key === 'Enter') {
          event.stopPropagation();
          handleFinishEdit();
        }
      }}
      // Trim the entered value to 2 as max length
      onInput={(e: ChangeEvent<HTMLInputElement>) => {
        e.target.value = Math.max(0, Number(e.target.value)).toString().slice(0, 2);
      }}
      inputProps={{
        max: maxValue,
        min: 0,
        // https://github.com/mui-org/material-ui/issues/5309
        // maxLenght: 2,
      }}
    />
  ) : (
    <Button color="inherit" onClick={() => setIsEditing(true)}>
      <Typography variant="h3">{value}</Typography>
    </Button>
  );
};
